import React from 'react'

import { 
    BlurbContainerDiv,
    BlurbContainerContentsDiv,
    BlurbContentsDiv,
    BlurbSectionHeader,
    BlurbDescription 
} from '../../Styles/Components/BlurbStyles'

function Blurb(props) {
    return (
        <BlurbContainerDiv id="blurb-section">
            <BlurbContainerContentsDiv>
                <BlurbContentsDiv>
                    <BlurbSectionHeader>Fill applications with ease and speed</BlurbSectionHeader>
                    <BlurbDescription>Only a few clicks from a completed application. Supports job applications and resumes only.</BlurbDescription>
                </BlurbContentsDiv>
            </BlurbContainerContentsDiv>
        </BlurbContainerDiv>
    )
}

export default Blurb